import { EnquiryRequestService } from 'client/services';
import { formDataToJson } from 'client/utils/helpers/Enquiry/Enquiry';
import { v4 as uuid } from 'uuid';
import { logWithPrefix } from 'client/utils/logging';
import FeaturesService from 'client/services/Features/Features.service';

const log = logWithPrefix('enquiries');
const logTitle = 'CreateEnquiry';

const action = async ({ request }) => {
    const formData = await request.formData();
    const enquiry = formDataToJson(formData) || {};

    if (!enquiry?.userJourneyTransId) {
        enquiry.userJourneyStartTime = performance.now();
        enquiry.userJourneyTransId = uuid();
        log(logTitle, 'start journey using tx-id: ' + enquiry.userJourneyTransId);
    }

    const enquiryFeatures = await FeaturesService.getEnquiryFeatures(enquiry.geometry);

    if (request.method === 'POST') {
        const transId = enquiry.userJourneyTransId;
        const startTime = enquiry.userJourneyStartTime;

        delete enquiry.userJourneyTransId;
        delete enquiry.userJourneyStartTime;

        try {
            log(logTitle, 'end journey using tx-id: ' + transId + ', took: ' + (performance.now() - startTime).toFixed(2) + ' ms');

            const response = await EnquiryRequestService.postEnquiry(enquiry, transId);
            if (response?.enquiryId) {
                if (enquiryFeatures.organisationsWithEnhancedMeasures.size > 0) {
                    log(logTitle, `enquiry contains organisations with sensitive areas: ${Array.from(enquiryFeatures.organisationsWithEnhancedMeasures)}`);
                }
                return {
                    ...enquiryFeatures,
                    enquiry,
                    createdEnquiryId: response.enquiryId
                };
            }
        } catch (error) {
            enquiry.userJourneyTransId = transId;
            enquiry.userJourneyStartTime = startTime;
            return {
                ...enquiryFeatures,
                enquiry,
                error
            };
        }
    }

    if (enquiry.geometry) {
        return {
            ...enquiryFeatures,
            enquiry
        };
    }

    return {
        enquiry
    };
};

export default action;
